






















import { IDialog } from "@/lib/interfaces/dialog.interface";
import PartnerFallbackMixin from "@/mixins/PartnerFallbackMixin.vue";
import { IPersonPhone } from "@/models/person-phone.entity";
import { mixins } from "vue-class-component";
import { Component, Prop, PropSync } from "vue-property-decorator";
import ConfirmActionDialog from "../utility/ConfirmActionDialog.vue";
import PersonPhoneForm from "./PersonPhoneForm.vue";

@Component({
  components: {
    PersonPhoneForm,
    ConfirmActionDialog
  },
  filters: {}
})
export default class PersonPhoneDialog extends mixins(PartnerFallbackMixin) implements IDialog {
  @Prop() value!: IPersonPhone;
  @Prop({ default: "components.partner.PersonPhoneDialog.title" }) title!: string;
  @PropSync("isDialogActive", { type: Boolean, required: true }) dialogModel!: boolean;

  isLoading = false;

  isFormValid = false;

  isDialogActive = false;

  open() {
    this.dialogModel = true;
  }

  close() {
    this.dialogModel = false;
  }

  onRightClick() {
    this.$emit("save", this.value);
    this.close();
  }
}
